import { Inbox } from "lucide-react";

export function EmptyList() {
  return (
    <div
      className="flex min-h-[14rem] w-full flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-zinc-200 bg-white/60 px-6 py-12 text-center dark:border-zinc-700 dark:bg-zinc-900/40"
      role="status"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-zinc-100 dark:bg-zinc-800">
        <Inbox className="h-6 w-6 text-zinc-400" aria-hidden />
      </div>
      <p className="max-w-sm text-sm font-medium text-zinc-700 dark:text-zinc-300">
        Nenhum registro encontrado.
      </p>
      <p className="max-w-sm text-xs text-zinc-500 dark:text-zinc-500">
        Quando houver dados, eles aparecerão aqui.
      </p>
    </div>
  );
}
